<div class="background">
  <div class="successMessage alert-dismissible">
    <div *ngIf="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}
      <button type="button" class="btn-close" (click)="removeMessage()" data-bs-dismiss="alert"
        aria-label="Close"></button>
    </div>
    <div *ngIf="warningMessage" class="alert alert-warning" role="alert">
      {{ warningMessage }}
      <button type="button" class="btn-close" (click)="removeMessage()" data-bs-dismiss="alert"
        aria-label="Close"></button>
    </div>
  </div>

  <div class="container-fluid">
    <div class="d-flex flex-row">
      <div class="p-2 flex-grow-1">
        <h2 class="heading">Usage V Receipt Graph</h2>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="card">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <span class="v1"></span>
                <label class="searchLable">DOCK</label>
                <p-dropdown [(ngModel)]="selectedDock" [options]="dockList" [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'" placeholder="--Select--" [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true" optionLabel="dock" [panelStyle]="{ width: '80%' }" [filter]="true"
                  appendTo="body" scrollHeight="150px" (onChange)="onDockChange()" [filterBy]="'dock'"
                  [resetFilterOnHide]="true">
                </p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">SPECIALIST</label>
                <p-dropdown [(ngModel)]="selectedSpecialist" [options]="specialistList" [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'" placeholder="--Select--" [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true" optionLabel="employee" [panelStyle]="{ width: '50%' }" [filter]="true"
                  appendTo="body" scrollHeight="150px" [filterBy]="'employee'" (onChange)="specialistChange()"
                  [resetFilterOnHide]="true">
                </p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">PART NO</label>
                <p-dropdown [(ngModel)]="selectedPartNo" [options]="partNoList" [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'" placeholder="--Select--" [style]="{ width: '100%' }"
                  [resetFilterOnHide]="true" optionLabel="item_id" [panelStyle]="{ width: '100%' }" [filter]="true"
                  appendTo="body" scrollHeight="150px" (onChange)="onPartNoChange()" [filterBy]="'item_id'"
                  [readonly]="partSelect" [resetFilterOnHide]="true">
                </p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3">
              <div class="drpchildctrl">
                <label class="searchLable">KANBAN </label>
                <p-dropdown #kanbanDropdown [(ngModel)]="selectedKanban" [options]="kanbanList"
                  [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" placeholder="--Select--"
                  [style]="{ width: '100%' }" optionLabel="kanban" [panelStyle]="{ width: '60%' }" [filter]="true"
                  appendTo="body" (onChange)="onKanbanChange()" [filterBy]="'kanban'" [readonly]="kanbanselect"
                  scrollHeight="150px" [resetFilterOnHide]="true"
                  >
                </p-dropdown>

              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3 reset_btn">
              <label class="resetIcon" (click)="onResetDropDown()">
                <img src="./assets/images/Group 115380.png" alt="refresh icon" />
              </label>
              <label class="resetlabel" (click)="onResetDropDown()">Reset</label>
              <span class="vertical"></span>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3 search">
              <button class="search_btn" (click)="onSearch()">SEARCH</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="card">
        <div class="container-fluid">
          <div class="row" *ngIf="chartData.length != 0">
            <!-- *ngIf="chartData.length != 0" -->
            <div class="col-1">
              <div class="drpchildctrl">
                <label class="searchLable">COUNTS</label>
                <p-dropdown [filter]="true" [itemSize]="12" placeholder="Select"
                  [style]="{ width: '115px', height: '25px' }" [panelStyle]="{ width: '232px' }" scrollHeight="150px"
                  [options]="count" optionLabel="countString" [appendTo]="'body'" [autoWidth]="true"
                  [(ngModel)]="selectedCount" (onChange)="onCountChange($event)" [showTransitionOptions]="'0ms'"
                  [hideTransitionOptions]="'0ms'" [resetFilterOnHide]="true" [filterBy]="'countString'"
                  [resetFilterOnHide]="true">
                </p-dropdown>
              </div>
            </div>
            <div class="col-1">
              <div class="drpchildctrl">
                <label class="searchLable left">RENBAN</label>
                <input [(ngModel)]="renban" class="key" type="text" placeholder="Enter" maxlength="6" autoWidth="false"
                  readonly="true" />
              </div>
            </div>
            <div class="col-1 search">
              <button class="set left" style="margin-bottom: 3px" (click)="set()">
                SET
              </button>
            </div>
            <div class="col-1 ">
              <div class="drpchildctrl">
                <label class="searchLable">Stocking DT From</label>
                <p-dropdown [filter]="true" [(ngModel)]="stockDtFrom" [itemSize]="30" placeholder="Select"
                  [style]="{ width: '100px', height: '25px' }" scrollHeight="100px" [options]="UsageVersusReceipt"
                  (onChange)="onStockingDtFromChange()" optionLabel="stocking_date" [appendTo]="'body'"
                  [autoWidth]="false" [filterBy]="'stocking_date'" [resetFilterOnHide]="true"></p-dropdown>
              </div>
            </div>
            <div class="col-1">
              <div class="drpchildctrl">
                <label class="searchLable">Stocking DT To</label>
                <p-dropdown [filter]="true" [(ngModel)]="stockDtTo" [itemSize]="30" placeholder="Select"
                  [style]="{ width: '100px', height: '25px' }" scrollHeight="100px"
                  [options]="stockingToRange.length > 0 ? stockingToRange:UsageVersusReceipt"
                  (onChange)="onStockingDtToChange()" optionLabel="stocking_date" [appendTo]="'body'"
                  [autoWidth]="false" [filterBy]="'stocking_date'" [resetFilterOnHide]="true"></p-dropdown>
              </div>
            </div>
            <div class="col-xl-1 col-md-2 col-sm-3 reset_btn">
              <label class="resetIcon" (click)="onResetGraph()">
                <img src="./assets/images/Group 115380.png" alt="refresh icon" />
              </label>
              <label class="resetlabel" (click)="onResetGraph()">Reset</label>
              <span class="vertical"></span>
            </div>
            <div class="col-2 ">
              <div class="drpchildctrl">
                <label class="searchLable">CHART</label>
                <p-dropdown [filter]="true" [(ngModel)]="selectedchart" [itemSize]="30" placeholder="Select"
                  [style]="{ width: '200px', height: '25px' }" scrollHeight="100px" [options]="dropDownchartOptions"
                  (onChange)="onChartChange()" optionLabel="chart_name" [appendTo]="'body'" [autoWidth]="false"
                  [filterBy]="'chart_name'" [resetFilterOnHide]="true"></p-dropdown>
              </div>
            </div>
            <div class="col-2 ">
              <div class="drpchildctrl" *ngIf="accessEdit">
                <label class="searchLable">ACTION</label>
                <p-dropdown [filter]="true" [itemSize]="30" placeholder="Select"
                  [style]="{ width: '200px', height: '25px' }" scrollHeight="100px" [options]="actionOptions"
                  optionLabel="action_name" [appendTo]="'body'" [autoWidth]="false" [ngModel]="selectedAction"
                  (onChange)="onActionSelect($event.value)" [filterBy]="'action_name'"
                  [resetFilterOnHide]="true"></p-dropdown>
              </div>
            </div>
            <div class="col-2">
              <span *ngIf="accessEdit">
                <img (click)="performToBeCountedList()" class="img-tool1" src="./assets/images/Add.svg"
                  alt="download icon" title="Add to 'To Be Counted'" />
              </span>
              <span>
                <img class="img-tool" (click)="generateExcel()" src="./assets/images/download.svg" alt="download icon"
                  title="Download" />
              </span>
              <!-- (click)="openRecalculateDialog()" -->
              <span *ngIf="accessEdit" [attr.disabled]="isRecalculateEnabled ? true : null">
                <img class="img-tool1" src="./assets/images/calculator.svg" title="Recalculate"
                  (click)="openRecalculateDialog()" alt="edit button icon" />
              </span>
              <span>
                <!-- <img class="img-tool1" (click)="isExpendChart = !isExpendChart ;" src="./assets/images/Expand.svg"
                  [title]="isExpendChart ? 'Collapse' : 'Expand'" alt="Expand button icon" /> -->
                  <img class="img-tool1" (click)="isExpendChart = !isExpendChart ; divWidth = 100;" src="./assets/images/Expand.svg"
                  [title]="isExpendChart ? 'Collapse' : 'Expand'" alt="Expand button icon" />
              </span>
              <label class="resetlabel1" [routerLink]="['/inventory/parts-count']">
                <p style="color: blue">Parts Count</p>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="row manual-width">
                <!-- Left side with 3 AG-Grid components stacked vertically -->
                <div class="col-3" *ngIf="!isExpendChart">
                  <!-- First AG-Grid -->
                  <div class="gridContent">
                    <ag-grid-angular class="ag-theme-balham uvr-class" #partGrid [columnDefs]="columnDefPartNo"
                      style="width: 100%; height: 20vh" [gridOptions]="morninggridoptions" [rowData]="partnorowdata"
                      [tooltipMouseTrack]="true" [context]="context" (gridReady)="onGridReady($event)"
                      [headerHeight]="45" (rowClicked)="onRowClicked($event)">
                    </ag-grid-angular>
                  </div>

                  <!-- Second AG-Grid -->
                  <div class="gridContent">
                    <ag-grid-angular class="ag-theme-balham uvr-class" [columnDefs]="columnDefManualAdj"
                      style="width: 100%; height: 20vh" [gridOptions]="morninggridoptions" [rowData]="manualAdjGrid"
                      [tooltipMouseTrack]="true" [context]="context" (gridReady)="onGridReady($event)"
                      [headerHeight]="45">
                    </ag-grid-angular>
                  </div>

                  <!-- Third AG-Grid -->
                  <div class="gridContent">
                    <ag-grid-angular class="ag-theme-balham uvr-class" #actionGrid [columnDefs]="columnDefAction"
                      style="width: 100%; height: 35vh" [gridOptions]="morninggridoptions" [rowData]="actionrowdata"
                      [tooltipMouseTrack]="true" [context]="context" (gridReady)="onGridReady($event)"
                      [headerHeight]="45">
                    </ag-grid-angular>
                  </div>
                </div>

                <!-- Right side with the chart taking up 9 columns -->
                <div [ngClass]="{ 'col-9': !isExpendChart,'col-12': isExpendChart}">
                  <div class="title-heading">
                    <h4>{{chartTitle}}</h4>
                  </div>
                  <!-- <div [ngClass]="{ 'hide-zoom-icon': !isExpendChart, 'show-zoom-icon': isExpendChart}"> -->

                  <div class="show-zoom-icon" *ngIf="chartData.length != 0">
                    <span>
                      <img (click)="expendChart()" class="img-tool1" src="./assets/images/expend-left-right.svg"
                        alt="expend chart icon" title="Expend chart" />
                    </span><br>
                    <span>
                      <img class="img-tool1" (click)="shrinkChart()" src="./assets/images/shrink-left-right.svg"
                        alt="shrink icon" title="shrink chart" />
                    </span>
                    <br>
                    <span>
                      <img src="./assets/images/Group 115380.png" class="img-tool1" (click)="resetChart()"
                        alt="reset icon" title="reset chart" />
                    </span>
                  </div> 
                  <div [ngClass]="{'chartScroller': divWidth != 100 }">
                  <div id="myChart" [style.width.%]="divWidth"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading... Please wait...</p>
  </ngx-spinner>
</div>